import React from 'react'

const Footer = () => {
  return (
    <div className=' max-w-full font-semibold pt-4  '>
    <div className='bg-[#0077B6] flex flex-col item-center justify-center mx-auto py-5'>
        <div className='text-white  text-center text-xl sm:text-2xl pb-2'>Rajiv Ranjan</div>
        <div className='text-white  text-center text-md sm:text:lg pb-1'>Made with ❤️ © 2024 copyright all right reserved</div>
        <div className='text-white text-center text-md sm:text:lg'>Designed & Developed by RAJIV RANJAN</div>
    </div>
    </div>
  )
}

export default Footer